export const GET_COMPONENT_USAGE_REQUESTED = 'component/GET_COMPONENT_USAGE_REQUESTED';
export const GET_COMPONENT_USAGE_REJECTED = 'component/GET_COMPONENT_USAGE_REJECTED';
export const GET_COMPONENT_USAGE_FULLFILLED = 'component/GET_COMPONENT_USAGE_FULLFILLED';
export const CLEAR_COMPONENT_USAGE = 'component/CLEAR_COMPONENT_USAGE';
export const versionStateMapper = {
  1: 'Live',
  2: 'Saved'
};
